import type { TicketType } from '@/types/event'

function formatFCFA(n: number) {
  return new Intl.NumberFormat('fr-FR').format(n) + ' FCFA'
}

interface Props {
  types: TicketType[]
  selected: TicketType | null
  onSelect: (type: TicketType) => void
}

export function TicketTypeSelector({ types, selected, onSelect }: Props) {
  return (
    <div className="flex flex-col gap-2">
      {types.map((type) => {
        const isFull = type.is_full
        const isSelected = selected?.id === type.id

        return (
          <button
            key={type.id}
            type="button"
            disabled={isFull}
            onClick={() => !isFull && onSelect(type)}
            className={`w-full text-left rounded-xl border-2 p-4 transition-all duration-150 ${
              isFull
                ? 'border-gray-100 bg-gray-50 opacity-60 cursor-not-allowed'
                : isSelected
                ? 'border-primary-500 bg-primary-50'
                : 'border-gray-200 bg-white hover:border-gray-300'
            }`}
          >
            <div className="flex items-center justify-between gap-4">
              <div className="flex items-center gap-3">
                {/* Radio dot */}
                <div className={`w-4.5 h-4.5 rounded-full border-2 flex items-center justify-center shrink-0 ${
                  isSelected ? 'border-primary-500' : 'border-gray-300'
                }`}>
                  {isSelected && (
                    <div className="w-2 h-2 rounded-full bg-primary-500" />
                  )}
                </div>
                <div>
                  <span className={`font-semibold text-base ${isSelected ? 'text-primary-700' : 'text-gray-900'}`}>
                    {type.name}
                  </span>
                  {type.description && (
                    <p className="text-sm text-gray-500 mt-0.5">{type.description}</p>
                  )}
                  {isFull ? (
                    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-gray-200 text-gray-600 mt-1">
                      Complet
                    </span>
                  ) : type.tickets_available !== null ? (
                    <p className="text-xs text-gray-400 mt-1">
                      {type.tickets_available} place{type.tickets_available !== 1 ? 's' : ''} disponible{type.tickets_available !== 1 ? 's' : ''}
                    </p>
                  ) : (
                    <p className="text-xs text-gray-400 mt-1">Places illimitées</p>
                  )}
                </div>
              </div>
              <div className="shrink-0 text-right">
                <span className={`font-bold text-lg font-mono ${isSelected ? 'text-primary-700' : 'text-gray-900'}`}>
                  {formatFCFA(type.price)}
                </span>
              </div>
            </div>
          </button>
        )
      })}
    </div>
  )
}
